import { TreeSelect } from "primereact/treeselect";
import { forwardRef, JSX } from "react";
import { Location } from "../../models";
import PanelTemplate from "./templates/PanelTemplate";

export interface TreeNode {
    children?: TreeNode[];
    id: string;
    isActive?: boolean;
    isExpanded?: boolean;
    name: string;
}

interface LocationTreeSelectProps {
    onHide?: () => void;
    onLocationSelect?: ({
        companyId,
        locationId,
    }: {
        companyId: string;
        locationId: string;
    }) => void;
    onSearchChange?: (search: string) => void;
    onToggleExpand?: (options: TreeNode[]) => void;
    options?: TreeNode[];
    search?: string;
    selectedLocation?: Location;
    valueTemplate: JSX.Element;
}

const LocationTreeSelect = forwardRef<TreeSelect, LocationTreeSelectProps>(
    function LocationTreeSelect(props: LocationTreeSelectProps, ref) {
        const {
            onHide = () => {},
            onLocationSelect = () => {},
            onSearchChange = () => {},
            onToggleExpand = () => {},
            options = [],
            search = "",
            selectedLocation,
            valueTemplate,
        } = props;

        return (
            <TreeSelect
                ref={ref}
                options={[]}
                placeholder={" "} // Needed to display ValueTemplate
                valueTemplate={() => valueTemplate}
                onHide={onHide}
                panelFooterTemplate={() => (
                    <PanelTemplate
                        onLocationSelect={onLocationSelect}
                        onSearchChange={onSearchChange}
                        onToggleExpand={onToggleExpand}
                        options={options}
                        search={search}
                        selectedLocation={selectedLocation}
                    />
                )}
                pt={{
                    wrapper: {
                        className: "hidden",
                    },
                    panel: {
                        className:
                            "max-w-[100vw] w-120 rounded-[6px] overflow-hidden",
                    },
                    header: {
                        className: "hidden",
                    },
                }}
            />
        );
    }
);

export default LocationTreeSelect;
